module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_fruity_berries-f6cf28b9.png";